import AnalysisShare from './components/AnalysisShare';
export default AnalysisShare;